export enum ChatNavOptionsEnum {
    Profile = "Profile",
    Chat = "Chat",
    Call = "Call",
    Calendar = "Calendar",
    FamilyPortal = "Family Portal"
}
